const ICCID_REGEX = /^89(\d{17,18})$/;
const ICCID_SPECIAL_REGEX = /^00(\d{17,18})$/;

export { ICCID_REGEX, ICCID_SPECIAL_REGEX };

/**
 * Ensure the given ICCID is defined, and replace the "89" prefix
 * also handle case when ICCID is only "0"s
 * @param {String} iccid ICCID
 * @return {String} ICCID without prefix
 */
export default iccid => iccid ? iccid.replace(ICCID_SPECIAL_REGEX, '$1').replace(ICCID_REGEX, '$1') : iccid;